require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./calculators-im-retired-how-long-will-my-savings-last.json") })
        }
      }, "path---calculators-im-retired-how-long-will-my-savings-last");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---calculators-im-retired-how-long-will-my-savings-last!./.cache/json/calculators-im-retired-how-long-will-my-savings-last.json
// module id = 2015
// module chunks = 231608221292675